/* eslint-disable */
//import './lib/jquery-3.4.1.min.js';
import '../scss/forms.scss'
import './base/icon.font.js'
import InitFormCounter from './components/forms/form-counter.js'
import InitFormDropdown from './components/forms/form-dropdown.js'
import InitFormFileInput from './components/forms/form-file-input.js'
import InitFormInput from './components/forms/form-input.js'

/**
 * Import Components
 */
import InitForms from './components/forms/form.js'

/**
 * Init - initalises all project classes
 */
class Init {
  constructor() {
    new InitFormFileInput()
    console.log('Initialising forms.js...')

    // if(!(document.location.href.indexOf("www.mq.edu.au") >= 0) && !(document.domain.indexOf("dev.mq.edu.au") >= 0) && !(document.domain.indexOf("localhost") >= 0) && !(document.location.href.indexOf("page.mq.edu.au") >= 0)){
    // 	document.domain = "mq.edu.au"
    // 	console.log('Setting document domain to mq.edu.au')
    // }

    //Base Initialisers
    new InitForms()
  }
}

new Init()

window.forms = function () {
  new InitFormInput()
  new InitFormDropdown()
  new InitFormCounter()
  new InitForms()
}
